import { MatchForecast, valueof } from './MatchForecast';
import { Mediafile } from '../Media';
import { Bookie, FormattedOdds, PriceType, Stake } from '../utils';
import { Channel, Tip, TipType } from './Tip';
import { Validations } from './Validations';

export class SimpleTip implements Tip {
  type: TipType = 'SIMPLE';
  channel: Channel;
  matchForecasts: MatchForecast[];
  analysis: string;
  rawAnalysis: string;
  media: Mediafile[];
  stake: number;
  bookie: Bookie;
  betImage: Mediafile | null;
  priceType: PriceType;
  pricingTierCode: string;
  accumulatedOdds: FormattedOdds;
  validations: Validations;
  discountPercentage: number = 0;

  constructor(
    matchForecast: MatchForecast,
    bookie: Bookie,
    stake: Stake,
    channel: Channel,
  ) {
    this.matchForecasts = [matchForecast];
    this.analysis = '';
    this.rawAnalysis = '';
    this.media = [];
    this.stake = 0;
    this.bookie = bookie;
    this.betImage = null;
    this.priceType = channel.type === 'PREMIUM' ? 'PREMIUM' : 'FREE';
    this.pricingTierCode = '';
    this.accumulatedOdds = matchForecast.formatted_odds;
    this.validations = new Validations([matchForecast]);
    this.channel = channel;
  }

  public setValue(key: keyof SimpleTip, value: valueof<SimpleTip>) {
    this.setAttribute<SimpleTip, keyof SimpleTip>(this, key, value);
  }
  private setAttribute<T extends Object, U extends keyof T>(
    obj: T,
    key: U,
    value: T[U],
  ) {
    obj[key] = value;
  }

  public setMatchForecast(matchForecast: MatchForecast): void {
    this.matchForecasts[matchForecast.index] = matchForecast;
  }

  public setAccumulatedOdds(
    matchForecast: MatchForecast,
    odds: FormattedOdds,
  ): void {
    this.matchForecasts[matchForecast.index].formatted_odds = odds;
    this.accumulatedOdds = odds;
  }
  public recalculateAccumulatedOdds(): void {
    this.accumulatedOdds = this.matchForecasts[0].formatted_odds;
  }
  public addMatchForecast(_: MatchForecast): void {
    return;
  }
  public checkStepValidity(stepNumber: number): boolean {
    return this.validations.checkStepValidity(stepNumber);
  }
  public runValidations() {
    this.validations.runValidations(this);
  }
  public deleteMatchForecast(index: number): void {
    return;
  }
}
